const state = {
  user: {},
  isLoaded: false
}

export default state
